import Api from '@/services/Api';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/servicos156';
export default {
    buscarTopServicosRegiao,
    buscarTopServicosOrgao,
    buscarTopServicosDemandados,
    buscarTopServicosConsolidados,
    buscarTopTemasDemandados,
    buscarTopAssuntosDemandados,
    buscarSolicitacoesConsolidadoPorOrgao,
    buscarSolicitacoesPorCanal,
    buscarSolicitacoesConsolidado,
    buscarEvolucaoEstoqueSolicitacao,
    buscarServicosNaoGeorreferenciados
};

function buscarTopServicosRegiao ({ topReqs, intervalo, ordenacao, filtroId }) {
    let params = { 'top': topReqs, 'intervalo': intervalo, 'ordenacao': ordenacao, 'filtroId': filtroId  };
    return Api.get(`${RECURSO}/topServicosPorRegiao${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarTopServicosOrgao ({ topReqs, intervalo, ordenacao, filtroId }) {
    let params = { 'top': topReqs, 'intervalo': intervalo, 'ordenacao': ordenacao, 'filtroId': filtroId };
    return Api.get(`${RECURSO}/topServicosPorOrgao${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarTopServicosDemandados ({ topReqs, intervalo }) {
    let params = { 'top': topReqs, 'intervalo': intervalo };
    return Api.get(`${RECURSO}/topServicosDemandados${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarTopServicosConsolidados ({ topReqs, intervalo, ordenacao }) {
    let params = { 'top': topReqs, 'intervalo': intervalo, 'ordenacao': ordenacao};
    return Api.get(`${RECURSO}/topServicosConsolidados${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarSolicitacoesConsolidadoPorOrgao ({ intervalo }) {
    let params = { 'intervalo': intervalo };
    return Api.get(`${RECURSO}/solicitacoes/porOrgao${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarSolicitacoesPorCanal () {
    // let params = { 'top': topReqs, 'intervalo': intervalo };
    return Api.get(`${RECURSO}/solicitacoes/porCanal`);
}

function buscarSolicitacoesConsolidado () {
    return Api.get(`${RECURSO}/solicitacoes/consolidado`);
}

function buscarEvolucaoEstoqueSolicitacao ({ agrupamento }) {
    let params = { 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/solicitacoes/evolucaoEstoque${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarTopTemasDemandados ( { intervalo, top, ordenacao } ) {
    let params = { 'intervalo':intervalo , 'top': top, 'ordenacao':ordenacao};
    return Api.get(`${RECURSO}/topTemasDemandados${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarTopAssuntosDemandados ( { intervalo, top, ordenacao } ) {
    let params = { 'intervalo':intervalo , 'top': top, 'ordenacao':ordenacao};
    return Api.get(`${RECURSO}/topAssuntosDemandados${MetodosGlobais.createEncodeQuery(params)}`);
}

function buscarServicosNaoGeorreferenciados ({ intervalo }) {
    let params = { 'intervalo': intervalo };
    return Api.get(`${RECURSO}/servicosNaoGeorreferenciados${MetodosGlobais.createEncodeQuery(params)}`);
}